import * as React from 'react'
import './notification.scss'

interface IProps {
  className?: string
  children?: React.ReactNode
}

export const Notification = (props: IProps): JSX.Element => {
  return (
    <div className={`notification ${props.className || ''}`}>
      {props.children}
    </div>
  )
}
